import _ from 'lodash'
window._ = _
import popper from 'popper.js'
window.Popper = popper.default

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import moment from 'moment'
window.moment = moment

import $ from 'jquery'
window.$ = $;
window.jQuery = $;

// Shim missende jQuery-plugins (BS4-plugins die in BS5 weg zijn, of plugins die niet
// goed attachen in de bundle) -> no-op zodat ready-handlers niet crashen
// ("X is not a function"). In een ready-handler zodat ALLE imports al geladen zijn:
// alleen wat echt ontbreekt wordt een no-op; bestaande (echte) plugins blijven ongemoeid.
$(function () {
    ['tooltip', 'popover', 'modal', 'tab', 'collapse', 'dropdown', 'carousel', 'toast',
     'button', 'bootstrapToggle', 'daterangepicker', 'DateTimePicker', 'DataTable', 'dataTable',
     'summernote', 'perfectScrollbar', 'select2'].forEach(function (name) {
        if ($.fn && typeof $.fn[name] !== 'function') {
            $.fn[name] = function () { return this; };
        }
    });
});

import 'datatables.net'

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios'
window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Vertaalt de Bootstrap 4-schrijfwijze in de views naar Bootstrap 5 en geeft de
// geschrapte jQuery-plugins terug. Moet ná de bundle staan.
import './components/bootstrap4-compat';


